var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            { attrs: { reverse: _vm.$wf.isSmDown } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: { model: _vm.model, label: _vm.$ct("label") },
                    on: {
                      inputLabel: function ($event) {
                        _vm.settings.Label = $event
                      },
                    },
                    model: {
                      value: _vm.settings.Field,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "Field", $$v)
                      },
                      expression: "settings.Field",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("label"), fancy: "" },
                    model: {
                      value: _vm.settings.Label,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "Label", $$v)
                      },
                      expression: "settings.Label",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }